import React from "react";
import { ReactComponent as SvgDesk } from "../svg/desk.svg";

export default function DeskIcon({ size = 64, color = "#32363F", ...props }) {
  return <SvgDesk width={size} height={size} style={{ color }} {...props} />;
}
